import { useEffect, useMemo } from "react";

import { useMemoizedFn } from "ahooks";
import { useSnapshot } from "valtio";
import { StockStore } from "../store/modules/stock";
import { StockData, StockState } from "../store";
import { useWS } from "../features";
import { useSelector } from "./useValtioSelector";

export const useSubscribeStock = (micDatas: string[] = [], enabled = true) => {
  const { register, unregister, ws } = useWS();
  const { updateStock, clearStockMap } = useSnapshot(StockStore);
  const micDatasHash = useMemo(() => {
    return micDatas.join(",");
  }, [micDatas]);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    // 获取所有 mic 值并去重
    const stockIds = [...new Set([...micDatas])];
    if (ws && stockIds.length > 0) {
      const registerTopic =
        `RG#` +
        JSON.stringify({
          stockIds,
        });
      clearStockMap();
      register(registerTopic, (event: Event) => {
        const data = event as unknown as {
          stockList: StockData[];
        };
        if (data.stockList?.length > 0) {
          updateStock(data.stockList);
        }
        // 处理 WebSocket 事件
      });
    }

    return () => {
      unregister();
    };
  }, [micDatasHash, register, unregister, updateStock, ws, clearStockMap]);
};

export const useStockField = (
  stockId: string,
  fieldKey: keyof StockData,
  fallbackValue?: string,
) => {
  const selector = useMemoizedFn((state: StockState) => {
    return {
      value: state.stockMap[stockId]?.[fieldKey] || fallbackValue,
    };
  });
  const { value } = useSelector(StockStore, selector);
  return { value };
};

export const useStockData = (stockId: string) => {
  const { data } = useSelector(StockStore, (state) => {
    return {
      data: state.stockMap[stockId],
    };
  });
  return { data };
};
